import { z } from "zod";

/**
 * 装修案例 —— 内容带货。
 *
 * ⚠️ 出参里**没有商品价格字段**可以直接写死：案例只记 `productIds`，
 *    价格由服务端按访问者的归属链现算。
 */

export const upsertCaseSchema = z.object({
  /** URL 里用的短名，前台按它取详情。 */
  slug: z
    .string()
    .min(2)
    .max(60)
    .regex(/^[a-z0-9-]+$/, "只能用小写字母、数字和连字符"),
  title: z.string().min(1).max(80),
  coverKey: z.string().max(300).optional(),
  /** 客厅 / 卧室 / 厨房 … 与商品的空间标签同一套。 */
  spaces: z.array(z.string().max(20)).max(10).optional(),
  style: z.string().max(20).optional(),
  areaSqm: z.number().positive().max(100_000).nullable().optional(),
  /** 装修预算，单位分。 */
  budget: z.number().int().min(0).nullable().optional(),
  contentMd: z.string().max(50_000).optional(),
  imageKeys: z.array(z.string().max(300)).max(50).optional(),
  /** 案例里出现的商品，前台渲染成可加购的卡片。⚠️ 服务端会校验这些 id 真实存在。 */
  productIds: z.array(z.number().int().positive()).max(50).optional(),
  published: z.boolean().optional(),
  /** 越大越靠前。 */
  sortOrder: z.number().int().optional(),
});
export type UpsertCaseInput = z.infer<typeof upsertCaseSchema>;

export const caseListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(50).optional(),
  cursor: z.string().optional(),
  space: z.string().max(20).optional(),
  style: z.string().max(20).optional(),
});
